import React from 'react';
import PropTypes from 'prop-types';
import MuiLoadingButton from '@mui/lab/LoadingButton';

const LoadingButton = (props) => {
  const {
    isDisabled = false,
    variant = 'contained',
    size = 'medium',
    color = 'inherit',
    isLoading = false,
    isLoadingPosition = '',
    label,
    type,
    startIcon = null,
    endIcon = null,
    onClick = null,
    ...more
  } = props;

  return (
    <MuiLoadingButton
      disabled={isDisabled}
      variant={variant}
      size={size}
      color={color}
      loading={isLoading}
      loadingPosition={isLoadingPosition}
      type={type}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      {...more}
    >
      {label}
    </MuiLoadingButton>
  );
};

LoadingButton.propTypes = {
  isDisabled: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.any,
  isLoading: PropTypes.bool,
  isLoadingPosition: PropTypes.string,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  startIcon: PropTypes.object,
  endIcon: PropTypes.object,
  onClick: PropTypes.func
}

export default LoadingButton;
